import styled from '@emotion/styled';
import { colors } from '@modernhealth/vital-foundation';
import { FC } from 'react';
import { HeadingText10, pxToRem } from '@modernhealth/vital-components';
import { useTranslation } from 'react-i18next';

const CareOptionRecommendedBadge = styled.div({
    backgroundColor: colors.blue55,
    borderRadius: pxToRem(6, 0, 10),
    padding: pxToRem(0, 8),
    position: 'absolute',
    left: -2,
    top: -2,
});

const CustomHeadingText10 = styled(HeadingText10)({
    fontSize: pxToRem(10),
    textTransform: 'uppercase',
});

export const CareRecommendationBadge: FC = () => {
    const { t } = useTranslation();
    return (
        <CareOptionRecommendedBadge>
            <CustomHeadingText10 fontColor="white" marginBottom={0}>
                {t('care:common.recommended')}
            </CustomHeadingText10>
        </CareOptionRecommendedBadge>
    );
};
